import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants"
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-subscription",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./subscription.component.css"]
})
export class SubscriptionComponent implements OnInit {

  subscriptionsData:any = [];
  currentPage:number | undefined;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  sortType: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  archiveUserSearch = "";
  closeSearch:boolean = false;
  public userDatas: any;
  public userPermissionData: any;

  constructor(private router: Router,private api: AdminService,private userDetailsService: UserDetailsService,private toastrService: ToastrService) { 
    
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData; 
    });
    this.userDetailsService.getRecruiterPermission();
    this.userDetailsService.userPermissionObserver.subscribe(res => {
      this.userPermissionData = res; 
    });
  }

  ngOnInit(): void {
    this.getSubscription();
  }

  getSubscription(){
    let params = new HttpParams(); 
    params = params.append("skip", this.pagination.skip.toString());
    params = params.append("limit", this.pagination.limit.toString());
    // params = params.append("planType", 0);
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    if (this.sortBy) { params.append("sortBy",this.sortBy.trim() ? this.sortBy.trim() : "");
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    this.api.getData(apiUrl._transaction,params)
    .subscribe(async (res) => {
      this.pagination.totalItems = res.data.count; 
      this.subscriptionsData = res.data.listing;
    })
  }

  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getSubscription();
  }
  downloadInvoice(id){
    const data={
      id:id
    }
    this.api.getData(apiUrl._downloadInvoice,data)
    .subscribe(async (res) => {
      this.toastrService.success("", "Downloaded invoice sent successfully on your email id!")
      this.getSubscription();
    })
  }
}
